import React from 'react'
import { CFView, DefaultScreen, MobileScreen } from 'components'
import { contactbg, mobileContactbg } from 'images'
import RestaurantDetails from './RestaurantDetails'
import Hours from './Hours'
import Map from './Map'
import SocialMedia from './SocialMedia'
import DownloadApp from './DownloadApp'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView maxWidth="800px" w="100%" column>
          <Map />
          <CFView
            column
            w="100%"
            pt="50px"
            pb="330px"
            mt="-5px"
            image={`url(${mobileContactbg}) bottom / cover no-repeat`}
          >
            <CFView w="100%" column alignCenter start>
              <RestaurantDetails />
              <Hours />
              {/* <SocialMedia /> */}
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView maxWidth="1400px" w="100%" column center>
          <Map />
          <CFView
            w="100%"
            pv="50px"
            row
            mt="-4px"
            justifyStart
            alignCenter
            image={`url(${contactbg}) center / cover no-repeat`}
          >
            <CFView w="100%" row justifyAround maxWidth="800px" ml="auto">
              <CFView column>
                <RestaurantDetails />
                {/* <SocialMedia /> */}
              </CFView>
              <Hours />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
